class YcAccordionSection extends HTMLElement {
    constructor() {
      super();

      this.textContainer =  this.querySelector('.yc-accordion-section-text')
        
      this.toggleSwitch = this.querySelector('.yc-accordion-section-title')

      this.toggleSwitch.addEventListener('click',this.toggle.bind(this))

    }


    open(){
        this.classList.add('open')

        let minHeight  = this.querySelector('.yc-accordion-section-text-inner').getBoundingClientRect().height;
        console.log(minHeight)

        minHeight = minHeight + 40;

        this.textContainer.style.height = `${minHeight}px`
        
    }

    close(){
        this.classList.remove('open')
        this.textContainer.style.height = '0px'
    }

    toggle(){
        if(this.classList.contains('open')){
            this.close()
        }else{
            this.open();
        }
    }

}

customElements.define('yc-accordion-section', YcAccordionSection);